import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, "表單管理", -1)
const _hoisted_2 = { class: "page__header" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增表單 ")
const _hoisted_4 = { class: "page__body" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("瀏覽")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("檢視")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("編輯")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("刪除表單")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 更多 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_CreateFormModal = _resolveComponent("CreateFormModal")!
  const _component_FormPreview = _resolveComponent("FormPreview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout_header, { class: "layout-header" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "header-menu-btn",
                  type: "link",
                  shape: "circle",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.appStore.collapsed=!_ctx.appStore.collapsed))
                }, {
                  icon: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "mdi mdi-menu",
                      style: _normalizeStyle({ color: '#212121', fontSize: '1.5rem' })
                    }, null, 4)
                  ]),
                  _: 1
                }),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_layout_content, { class: "layout-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_card, {
          class: "app-channel-forms-page",
          bordered: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      (_ctx.authStore.info.role > 3)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _ctx.openCreateFormModal,
                            type: "primary"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_component_PlusOutlined)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_a_table, {
                    key: 0,
                    columns: _ctx.columns,
                    "data-source": _ctx.formsData,
                    loading: _ctx.loading,
                    rowKey: "id",
                    bordered: "",
                    scroll: { x: 'max-content' }
                  }, {
                    bodyCell: _withCtx(({ column, text, record }) => [
                      (column.key === 'bind_roles')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(record.bind_roles.map(role => _ctx.RoleUtil.toString(role).zh).join(', ')), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.key === 'created_datetime')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.DateUtil.formatDatetime(record.created_datetime)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.key === 'action')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createVNode(_component_a_button, {
                              class: "mr-2",
                              size: "small",
                              onClick: ($event: any) => (_ctx.toViewerPage(record.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_a_button, {
                              class: "mr-2",
                              size: "small",
                              onClick: ($event: any) => (_ctx.openFormPreview(record))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_a_button, {
                              class: "mr-2",
                              size: "small",
                              onClick: ($event: any) => (_ctx.toEditorPage(record.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_a_dropdown, null, {
                              overlay: _withCtx(() => [
                                _createVNode(_component_a_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_popconfirm, {
                                      title: `確認刪除表單 ${record.name}？`,
                                      "ok-text": "確定",
                                      "cancel-text": "取消",
                                      danger: "",
                                      onConfirm: ($event: any) => (_ctx.deleteOne(record.id)),
                                      onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.message.info('取消刪除表單動作')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_menu_item, {
                                          key: "3",
                                          danger: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_8
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["title", "onConfirm"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, { size: "small" }, {
                                  default: _withCtx(() => [
                                    _hoisted_9,
                                    _createVNode(_component_DownOutlined)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1024)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "loading"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CreateFormModal, {
      visible: _ctx.createFormModal.visible,
      onConfirm: _ctx.handleCreateFormModalConfirm,
      onCancel: _ctx.handleCreateFormCancel
    }, null, 8, ["visible", "onConfirm", "onCancel"]),
    _createVNode(_component_FormPreview, {
      visible: _ctx.formPreview.visible,
      data: _ctx.formPreview.data,
      onClose: _ctx.handleFormPreviewClose
    }, null, 8, ["visible", "data", "onClose"])
  ], 64))
}